// TODO: incluir outros segmentos

export default {
  IMOBILIARIA: 1,
  ESCOLAS: 2,
};
